import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { uniqueId, map } from 'lodash';
import { Button, ContentBlock, Notification, Spinner } from 'sarsaparilla';
import { LinkDefaults, LinkProps } from '../../props/link';
import LinkEdit from "../../containers/StewardAssetEditPage/LinkEdit";

const propTypes = {
    linkType: PropTypes.string,
    value: PropTypes.shape({
        links: PropTypes.arrayOf(LinkProps)
    }),
    isLoading: PropTypes.bool
};

const defaultProps = {
    value: []
};

const LinkTab = ({ linkType, value, isLoading }) => {
    const [links, updateLinks] = useState(value.links);

    const addLink = () => {
        const newLinks = [ ...links, { ...LinkDefaults, _key: uniqueId('link-') }];
        updateLinks(newLinks);
    }

    const removeLink = (key) => {
        const newLinks = links.filter((link) => link._key !== key);
        updateLinks(newLinks);
    }

    if (isLoading) {
        return <Spinner isCentered={false} size="xl" />
    }

    return (
        <ContentBlock>
            <Notification type="info">
                Please allow up to 1 day for any updates to take place on recreation.gov.
            </Notification>

            { map(links, (link) => (
                <LinkEdit
                    key={link._key}
                    value={link}
                    linkType={linkType}
                    onRemove={removeLink} />
            ))}
            
            <Button onClick={addLink}>
                Add Link
            </Button>
        </ContentBlock>
    );
}

LinkTab.propTypes = propTypes;
LinkTab.defaultProps = defaultProps;

export default LinkTab;